"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteBucketAnalyticsConfigurationOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=DeleteBucketAnalyticsConfigurationOutput.js.map